import desertoursLogo from '@/assets/desertours-logo.png';

/**
 * Header de navigation avec logo
 */

export function NavigationHeader() {
  return (
    <header className="flex items-center justify-between w-full">
      <div className="flex gap-1.5 items-center">
        <div className="bg-white rounded-md w-8 h-8 flex items-center justify-center shadow-sm">
          <img src={desertoursLogo} alt="Desertours Logo" className="w-6 h-6 object-contain" />
        </div>
        <h1 className="text-sm font-semibold leading-5 text-zinc-700">Desertours CRM</h1>
      </div>

      {/* <Button
        variant="outline"
        size="sm"
        onClick={onNotificationClick}
        className="relative w-8 h-8 p-0 bg-white border-zinc-200 shadow-sm hover:bg-zinc-50"
        aria-label={`Notifications${notificationCount > 0 ? ` (${notificationCount})` : ''}`}
      >
        <Bell className="w-4 h-4" />
        {notificationCount > 0 && (
          <span
            className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center"
            aria-hidden="true"
          >
            {notificationCount > 9 ? '9+' : notificationCount}
          </span>
        )}
      </Button> */}
    </header>
  );
}
